import { css } from '@emotion/react'

import { typo } from '~/@common/styles'
import { fontFamily } from '~/@common/styles/fontFamily'
import { mediaQuery } from '~/@common/styles/mediaQuery'
import InfoTooltip from '~/@common/ui/InfoTooltip/InfoTooltip'

import SectionHeader from '../SectionHeader'

/**
 * "이번주 학습정보" — 정답률 + 푼 문제 수 카드
 */
const WeeklyStats = ({ rate, totalCount }: { rate: number; totalCount: number }) => {
  return (
    <div css={_Style}>
      <SectionHeader title="이번주 학습정보">
        <InfoTooltip
          title="이번주에 학습한 내용을 요약해드려요"
          items={['제출한 문제 수에 따라 푼 문제 수가 누적됩니다.']}
        />
      </SectionHeader>
      <div className="info-cards">
        <div className="info-card">
          <span className="info-label">정답률</span>
          <div className="info-value-row">
            <span className="info-value">{rate}</span>
            <span className="info-unit">%</span>
          </div>
        </div>
        <div className="info-divider" />
        <div className="info-card">
          <span className="info-label">푼 문제 수</span>
          <div className="info-value-row">
            <span className="info-value">{totalCount}</span>
            <span className="info-unit">문제</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WeeklyStats

const _Style = css`
  display: flex;
  flex-direction: column;

  .info-cards {
    display: flex;
    gap: 10px;
  }

  .info-card {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: 153px;
    background: var(--White);
    border-radius: 14px;
  }

  .info-label {
    ${typo.body02};
    color: var(--Colors-Gray-800);
  }

  .info-value-row {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .info-value {
    ${fontFamily.montserrat};
    font-size: 36px;
    font-weight: 700;
    color: var(--Colors-Gray-900);
  }

  .info-unit {
    ${typo.body02};
    color: var(--Colors-Gray-800);
  }

  /* 구분선: PC에서 숨김 */
  .info-divider {
    display: none;
  }

  /* 모바일 레이아웃 */
  ${mediaQuery.underTablet} {
    .info-cards {
      gap: 0;
      background: var(--White);
      border-radius: 14px;
    }

    .info-card {
      height: 97px;
      padding: 14px 0;
      border-radius: 0;
      background: transparent;
    }

    .info-divider {
      display: block;
      width: 1px;
      height: 50px;
      background: var(--Colors-Gray-200);
      align-self: center;
    }
  }
`
